<template>
  <div class="basic-block block-lucky-day" :style="styles">
    <div class="content-wrap">
      <div class="block-lucky-day__inn">
        <img :src="`${path}lucky_lead.png`" class="block-lucky-day__lead" alt="占いTVでは・・・">
        <img :src="`${path}lucky_suisyou.png`" class="block-lucky-day__suisyou" alt="少し先の未来あなたに訪れる「幸運な日」は">
        <lp-base-button label="今すぐ鑑定する" design="fill" :color-scheme="colorScheme" @clicked="clicked" />
        <lead-login :color-scheme="colorScheme" />
        <img :src="`${path}deco_flower.png`" class="block-lucky-day__flower" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import LeadLogin from '@/utvStore/components/recommend/lp/partials/LeadLogin'

export default {
  name: 'BlockLuckyDay',
  components: {
    LpBaseButton,
    LeadLogin,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: {
      type: String,
      require: true
    },
    lpId: Number,
  },
  data() {
    return {
      path: '/static/img/recommend/lp/kanoucoco/',
    }
  },
  computed: {
    styles(){
      return {
        '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : 'black',
        // '--second': !!this.colorScheme.second ? this.colorScheme.second : 'white',
        // '--grad-start': !!this.gradStart ? this.gradStart : this.colorScheme.gradStart,
        // '--grad-end': !!this.gradEnd ? this.gradEnd : this.colorScheme.gradEnd,
        // '--def-gradient': grad,
      }
    },
  },
  methods: {
    clicked(e) {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-subsc-button`,
        'event_label': `lucky`
      })
      location.href = this.$handoverParams(this.subscUrl)
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
//$l_col_second: var(--second);
// $l_col_grad_start: var(--grad-start);
// $l_col_grad_end: var(--grad-end);
// $l_def_gradient: var(--def-gradient);

.block-lucky-day {
  background: #FBF8F1;
  padding: 60px 0;
  &__inn {
    max-width: 460px;
    margin: auto;
    padding: 0 20px;
  }
  &__lead,
  &__suisyou {
    max-width: 100%;
    display: block;
  }
  &__lead {
    margin: 0 auto 24px;
  }
  &__suisyou {
    margin: 0 auto 40px;
  }
  &__flower {
    width: 84px;
    margin: 60px auto 0;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/blocks/BlockLuckyDay.vue